<template>
  <Bar
    id="my-chart-bar-percentage"
    :options="chartOptions"
    :data="chartData"
    :style="styles"
  />
</template>

<script>
import { Bar } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { floatingLabels } from "./nossoPlugin.js";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  floatingLabels,
);

export default {
  name: "BarChart1",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "pie-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 600,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {
        return { minHeight: "350px" };
      },
    },
  },
  data() {
    return {
      chartData: {
        type: "bar",
        labels: [
          ["Serviços", "Digitais"],
          ["Shows e", "eventos"],
          ["Usuários", "gerais"],
          ["TV aberta"],
          ["Rádio"],
          ["TV paga"],
          ["Cinema"],
        ],
        datasets: [
          {
            label: "2024",
            data: [
              481242731, 362227613, 350066538, 268287500, 144642623, 189734572,
              34707261,
            ],

            backgroundColor: "rgba(139, 197, 63, 0.5)",
            hoverBackgroundColor: "rgba(139, 197, 63, 1)",
            hoverBorderWidth: 0,
            barPercentage: 0.8,
            datalabels: {
              display: false,
            },
          },
          {
            label: "2025",
            data: [
              708456304, 410085688, 381909138, 280976914, 149054729, 148138964,
              26865538,
            ],
            backgroundColor: "rgba(139, 197, 63, 0.2)",
            hoverBackgroundColor: "rgba(139, 197, 63, 0.4)",
            hoverBorderWidth: 0,
            barPercentage: 0.8,
            datalabels: {
              display: false,
            },
          },
        ],
      },

      chartOptions: {
        // indexAxis: "y",
        plugins: {
          tooltip: {
            displayColors: true,
            backgroundColor: "#FFF",
            bodyColor: "#000",
            titleColor: " #000",
            padding: 10,
            callbacks: {
              title: (ctx) => ctx[0].label.replaceAll(",", " "),
              label: (x) => {
                // console.log(x);
                return `${x.dataset.label}: R$${x.formattedValue}`;
              },
            },
          },
          legends: { display: false },
          customDataLabels: { enable: true },
        },
        animation: {
          duration: 4000,
          // easing: 'easeInOutBounce',
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
            // position: "top",
          },
          y: {
            grace: 1,
            grid: {
              display: true,
            },
            border: {
              display: false,
            },
            ticks: {
              callback: function (value) {
                return value == 0 ? 0 : value / 1000000 + "M";
              },
            },
          },
        },
      },
      plugins: [floatingLabels],
    };
  },
};
</script>
